<app-quota-summary-bar></app-quota-summary-bar>
<div class="page-container">
  <div class="page-header">
    <h1>{{ 'pastSuppliers.title' | translate }}</h1>
    @if (!isManager()) {
      <button mat-raised-button color="primary" (click)="openAddDialog()">
        <mat-icon>add</mat-icon>
        {{ 'pastSuppliers.add' | translate }}
      </button>
    }
  </div>

  <!-- Tab bar -->
  <div class="tab-buttons">
    @for (tab of tabs; track tab.value) {
      <button
        class="tab-btn"
        [class.active]="activeTab() === tab.value"
        (click)="setActiveTab(tab.value)">
        <span class="tab-label">{{ tab.labelKey | translate }}</span>
        <span class="tab-count">{{ getTabCount(tab.value) }}</span>
      </button>
    }
  </div>

  @if (loading()) {
    <div class="loading-container">
      <mat-spinner diameter="50"></mat-spinner>
      <p>{{ 'pastSuppliers.loading' | translate }}</p>
    </div>
  } @else if (error()) {
    <div class="error-container">
      <mat-icon>error_outline</mat-icon>
      <p>{{ error() }}</p>
      <button mat-raised-button color="primary" (click)="loadData()">
        {{ 'pastSuppliers.retry' | translate }}
      </button>
    </div>
  } @else {
    <div class="table-container">
      <table mat-table [dataSource]="conclusionVolumes()" class="assignments-table">
        <!-- Number Column -->
        <ng-container matColumnDef="number">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let volume; let i = index">{{ i + 1 }}</td>
        </ng-container>

        <!-- Year Column -->
        <ng-container matColumnDef="year">
          <th mat-header-cell *matHeaderCellDef>{{ 'pastSuppliers.year' | translate }}</th>
          <td mat-cell *matCellDef="let volume">{{ volume.quotaYear }}</td>
        </ng-container>

        <!-- Applicant Name Column -->
        <ng-container matColumnDef="applicantName">
          <th mat-header-cell *matHeaderCellDef>{{ 'pastSuppliers.supplierName' | translate }}</th>
          <td mat-cell *matCellDef="let volume">{{ volume.applicantName }}</td>
        </ng-container>

        <!-- Distributed Volume Column -->
        <ng-container matColumnDef="distributedVolume">
          <th mat-header-cell *matHeaderCellDef class="text-right">{{ 'pastSuppliers.distributedVolume' | translate }}</th>
          <td mat-cell *matCellDef="let volume" class="text-right">
            {{ volume.distributedVolume | kgToTons }}
          </td>
        </ng-container>

        <!-- Delivered Volume Column -->
        <ng-container matColumnDef="deliveredVolume">
          <th mat-header-cell *matHeaderCellDef class="text-right">{{ 'pastSuppliers.deliveredVolume' | translate }}</th>
          <td mat-cell *matCellDef="let volume" class="text-right">
            {{ volume.deliveredVolume | kgToTons }}
          </td>
        </ng-container>

        <!-- Remaining Volume Column -->
        <ng-container matColumnDef="remainingVolume">
          <th mat-header-cell *matHeaderCellDef class="text-right">{{ 'pastSuppliers.remainingVolume' | translate }}</th>
          <td mat-cell *matCellDef="let volume" class="text-right">
            {{ volume.remainingVolume | kgToTons }}
          </td>
        </ng-container>

        <!-- Meat Type Column -->
        <ng-container matColumnDef="meatType">
          <th mat-header-cell *matHeaderCellDef>{{ 'pastSuppliers.meatType' | translate }}</th>
          <td mat-cell *matCellDef="let volume">{{ getMeatTypeName(volume.meatType) }}</td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>{{ 'pastSuppliers.status' | translate }}</th>
          <td mat-cell *matCellDef="let volume">
            <span class="status-badge" [class]="'status-' + volume.status.toLowerCase()">
              {{ getStatusLabel(volume.status) }}
            </span>
          </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>{{ 'pastSuppliers.action' | translate }}</th>
          <td mat-cell *matCellDef="let volume">
            <button mat-icon-button [matMenuTriggerFor]="menu" class="menu-trigger">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="addVolume(volume)">
                <span>{{ 'pastSuppliers.specifyDeliveredVolume' | translate }}</span>
              </button>
              <mat-divider></mat-divider>
              <button mat-menu-item (click)="revokeQuota(volume)">
                <span>{{ 'pastSuppliers.edit' | translate }}</span>
              </button>
              <mat-divider></mat-divider>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns();"></tr>

        <!-- No data row -->
        <tr class="mat-row no-data-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns().length">
            {{ 'pastSuppliers.noData' | translate }}
          </td>
        </tr>
      </table>
    </div>
  }
</div>
